import { Injectable, Inject } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { ApiService } from '@veritas-shared/services/api.service';
import { ToastService } from '@veritas-shared/services/toast.service';
import { WaitService } from '@veritas-shared/services/wait.service';
import { Observable } from 'rxjs';
import { IncidentListOutput } from '../models/incident-list-output';
import { ToastService as BeanToastService } from "bean-notification";
import { CommonHelper } from '@veritas-shared/helpers/common.helper';

@Injectable({
  providedIn: 'root'
})
export class IncidentService extends ApiService {

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string, toastService: ToastService, waitService: WaitService, commonHelper: CommonHelper, newToastService: BeanToastService) {
    super(http, baseUrl, toastService, waitService, commonHelper, newToastService);
  }

  public getIncidents(): Observable<IncidentListOutput> {
    return this.getBase<IncidentListOutput>('api/incident');
  }

}
